import { useService } from '@atlassian/jira-common-services/src/use-service';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { PACKAGE_NAME, TEAM_NAME, WIDGET_SERVICE_API_BASE_URL } from '../../common/constants';
import type { FeatureFlagsResponse, ReturnObject } from './types';

export const getFeatureFlags = async (): Promise<FeatureFlagsResponse | undefined> =>
	performGetRequest(`${WIDGET_SERVICE_API_BASE_URL}/featureFlags`).catch((error: Error) => {
		fireErrorAnalytics({
			meta: {
				id: 'getFeatureFlags',
				packageName: PACKAGE_NAME,
				teamName: TEAM_NAME,
			},
			error,
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	});

export const useGetFeatureFlags = (): ReturnObject => {
	const { loading, error, data, fetch } = useService<FeatureFlagsResponse>(getFeatureFlags);
	return [{ loading, error, data }, fetch];
};
